import { useMutation } from '@tanstack/react-query';
import { useNotifications } from '@toolpad/core';
import { Button, Stack, Typography } from '@mui/material';

import Api from '@barboxx/api';
import { Business, Place } from '@barboxx/models';

interface Props {
    place: Place;
    refreshData: () => void;
}

export function LinkBusiness({ place, refreshData }: Props) {
    const { business } = place;
    const notifications = useNotifications();

    const mutateBusinessCreate = useMutation({
        mutationKey: ['createBusiness'],
        mutationFn: (data: Business.CreateRequest) =>
            Api.Businesses.createBusiness(data),
    });

    const createBusiness = () => {
        mutateBusinessCreate
            .mutateAsync({ placeId: place.id, active: false })
            .then(data => {
                notifications.show('Business created!', {
                    severity: 'success',
                });
                refreshData();
            })
            .catch(e => {
                notifications.show('Error creating business link!', {
                    severity: 'error',
                });
            });
    };

    if (!business) {
        return (
            <Button variant="contained" onClick={createBusiness}>
                Create Business
            </Button>
        );
    }

    return (
        <Stack
            direction="row"
            alignItems="center"
            gap={2}
            justifyContent="space-between"
        >
            <Typography
                variant="button"
                color={business.active ? 'success' : 'error'}
            >
                {business.active ? 'Active' : 'Inactive'}
            </Typography>
            <Button variant="contained" href={`/businesses/${business.id}`}>
                Go to business
            </Button>
        </Stack>
    );
}
